import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'

import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { customerConversionTaskSave, customerConversionTaskUpdate } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { CustomerConversionTaskSaveParams } from '@/typings/api/gucangSale'
import { DcMessage } from '@dc-platform/dc-components'
import dayjs from 'dayjs'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerConversionTaskSaveParams>({})
const emit = __emit
const toggle = (row?: CustomerConversionTaskSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    editForm.value.monthDate = dayjs(row.monthDate)
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.id) {
        await customerConversionTaskUpdate({
          ...editForm.value,
          id: editForm.value.id,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_fbu'
        })
      } else {
        await customerConversionTaskSave({
          ...editForm.value,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_fbu'
        })
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "manageAreaId",
                label: "客户区域",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomerAreaCascader, {
                    appId: "cos_fbu",
                    value: editForm.value.manageAreaId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.manageAreaId) = $event)),
                    disabled: editForm.value.id
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "seller",
                label: "客户负责人",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserSelect, {
                    value: editForm.value.seller,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.seller) = $event)),
                    placeholder: "请选择客户负责人",
                    allowClear: "",
                    disabled: editForm.value.id
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "clueNum",
                label: "新线索数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.clueNum,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.clueNum) = $event)),
                    min: 0,
                    precision: 0,
                    max: 999999,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "customerContractNum",
                label: "新签约客户数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerContractNum,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.customerContractNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "customerDealAmount",
                label: "老成交客户新商机额"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerDealAmount,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((editForm.value.customerDealAmount) = $event)),
                    min: 0,
                    precision: 0,
                    max: 999999,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "customerDealNum",
                label: "新成交客户数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerDealNum,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.customerDealNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "customerPotentialNum",
                label: "新潜在客户数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerPotentialNum,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.customerPotentialNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "monthDate",
                label: "月度",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: editForm.value.monthDate,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.monthDate) = $event)),
                    picker: "month"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})